(function () {
  function fetchAvailability(url) {
    return fetch(url + '.js', { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { return p ? !!p.available : true; })
      .catch(function () { return true; });
  }

  function sortGrid(grid) {
    if (grid.__kikssSorting) return;
    grid.__kikssSorting = true;

    var items = Array.prototype.filter.call(grid.children, function (el) {
      return el.tagName === 'LI';
    });

    var checks = items.map(function (li) {
      if (li.dataset.kikssAvail) {
        return Promise.resolve({ li: li, available: li.dataset.kikssAvail === 'true' });
      }
      var link = li.querySelector('a.product-card__link, a[href*="/products/"]');
      if (!link) return Promise.resolve({ li: li, available: true });
      var href = link.getAttribute('href').split('?')[0];
      return fetchAvailability(href).then(function (available) {
        li.dataset.kikssAvail = String(available);
        return { li: li, available: available };
      });
    });

    Promise.all(checks).then(function (results) {
      var available = results.filter(function (r) { return r.available; }).map(function (r) { return r.li; });
      var unavailable = results.filter(function (r) { return !r.available; }).map(function (r) { return r.li; });
      var newOrder = available.concat(unavailable);
      var changed = false;
      for (var i = 0; i < items.length; i++) {
        if (items[i] !== newOrder[i]) { changed = true; break; }
      }
      if (changed && unavailable.length > 0) {
        var frag = document.createDocumentFragment();
        newOrder.forEach(function (li) { frag.appendChild(li); });
        grid.appendChild(frag);
      }
      grid.__kikssSorting = false;
    }).catch(function () {
      grid.__kikssSorting = false;
    });
  }

  function initGrids() {
    document.querySelectorAll('ul.product-grid').forEach(function (grid) {
      sortGrid(grid);
      if (!grid.__kikssObserved) {
        grid.__kikssObserved = true;
        var debounceTimer;
        var obs = new MutationObserver(function () {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () { sortGrid(grid); }, 200);
        });
        obs.observe(grid, { childList: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGrids);
  } else {
    initGrids();
  }
})();
